export default {
    topics: [
        {
            title: ' CheckEntityWriteRight ',
            href: 'sm-folder-CheckEntityWriteRight.html',
            attributes: { 'data-id': 'sm-folder-CheckEntityWriteRight' },
            menu: { hasChildren: false },
            tocID: 'sm-folder-CheckEntityWriteRight-d66e601',
            topics: [],
        },
        {
            title: ' DropSelection ',
            href: 'sm-folder-DropSelection.html',
            attributes: { 'data-id': 'sm-folder-DropSelection' },
            menu: { hasChildren: false },
            tocID: 'sm-folder-DropSelection-d66e609',
            topics: [],
        },
        {
            title: ' FindFirstAuthorized ',
            href: 'sm-folder-FindFirstAuthorized.html',
            attributes: { 'data-id': 'sm-folder-FindFirstAuthorized' },
            menu: { hasChildren: false },
            tocID: 'sm-folder-FindFirstAuthorized-d66e617',
            topics: [],
        },
        {
            title: ' HasFolderWriteRight ',
            href: 'sm-folder-HasFolderWriteRight.html',
            attributes: { 'data-id': 'sm-folder-HasFolderWriteRight' },
            menu: { hasChildren: false },
            tocID: 'sm-folder-HasFolderWriteRight-d66e625',
            topics: [],
        },
        {
            title: ' InheritParentFolderRights ',
            href: 'sm-folder-InheritParentFolderRights.html',
            attributes: { 'data-id': 'sm-folder-InheritParentFolderRights' },
            menu: { hasChildren: false },
            tocID: 'sm-folder-InheritParentFolderRights-d66e633',
            topics: [],
        },
        {
            title: ' LoadChildren ',
            href: 'sm-folder-LoadChildren.html',
            attributes: { 'data-id': 'sm-folder-LoadChildren' },
            menu: { hasChildren: false },
            tocID: 'sm-folder-LoadChildren-d66e641',
            topics: [],
        },
        {
            title: ' LoadChildrenWithPath ',
            href: 'sm-folder-LoadChildrenWithPath.html',
            attributes: { 'data-id': 'sm-folder-LoadChildrenWithPath' },
            menu: { hasChildren: false },
            tocID: 'sm-folder-LoadChildrenWithPath-d66e649',
            topics: [],
        },
        {
            title: ' MoveNode ',
            href: 'sm-folder-MoveNode.html',
            attributes: { 'data-id': 'sm-folder-MoveNode' },
            menu: { hasChildren: false },
            tocID: 'sm-folder-MoveNode-d66e657',
            topics: [],
        },
        {
            title: ' MoveSelection ',
            href: 'sm-folder-MoveSelection.html',
            attributes: { 'data-id': 'sm-folder-MoveSelection' },
            menu: { hasChildren: false },
            tocID: 'sm-folder-MoveSelection-d66e665',
            topics: [],
        },
        {
            title: ' NewFolder ',
            href: 'sm-folder-NewFolder.html',
            attributes: { 'data-id': 'sm-folder-NewFolder' },
            menu: { hasChildren: false },
            tocID: 'sm-folder-NewFolder-d66e673',
            topics: [],
        },
    ],
};

